import {
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  DialogActions,
  Button,
  Dialog,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

interface DisclaimerDialogProps {
  showDialog: boolean;
  handleClose: () => void;
}

const DisclaimerDialog: React.FC<DisclaimerDialogProps> = ({
  showDialog,
  handleClose,
}: DisclaimerDialogProps) => {
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={showDialog}
      onClose={handleClose}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Disclaimer
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers sx={{ textAlign: 'justify' }}>
        <Typography gutterBottom>
          This tool is provided for informational purposes only and does not
          constitute financial, legal, or investment advice. The investment
          suggestions generated by this tool are based on assumed investment
          options and user-provided goals. These suggestions do not guarantee
          any specific financial outcomes or returns.
        </Typography>
        <Typography variant="h6">No Financial or Investment Advice</Typography>
        <Typography gutterBottom>
          The information provided by this tool should not be considered
          professional financial advice. Users should consult a qualified
          financial advisor before making any investment decisions.
        </Typography>
        <Typography variant="h6">No Liability </Typography>
        <Typography gutterBottom>
          The creators of this tool make no representations or warranties
          regarding the accuracy, reliability, or completeness of the investment
          suggestions. We shall not be liable for any financial losses,
          incorrect decisions, or other consequences arising from the use of
          this tool.
        </Typography>
        <Typography variant="h6">No Data Storage</Typography>
        <Typography gutterBottom>
          This tool does not store any user data on a server. All information
          entered is saved locally in the user’s browser storage. Users are
          responsible for managing and securing their own data.
        </Typography>
        <Typography variant="h6">Use at Your Own Risk </Typography>
        <Typography gutterBottom>
          This tool is provided “as-is” without warranties of any kind. Users
          assume all risks associated with using the tool.
        </Typography>
        <Typography variant="h6">Changes & Updates</Typography>
        <Typography gutterBottom>
          The tool and its assumptions may be updated, modified, or discontinued
          at any time without prior notice. By using this tool, you acknowledge
          and agree to this disclaimer.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose}>
          AGREE
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DisclaimerDialog;
